<div class="customer-dropdown-wrap">

    <div class="customer-dropdown" [pnycDropdown]="customerMenu" #customerMenuDropdown="pnycDropdownApi"
        [dropdownCustomClass]="'customer-dropdown-menu-modal'" (closed)="onDropdownClosed()">
        @if (activeCustomer()) {
            <pnyc-avatar class="customer-dropdown-avatar" [profileImageUrl]="activeCustomer()!.profilePictureUrl ?? ''"
                [userFullName]="activeCustomer()!.firstName + ' ' + activeCustomer()!.lastName">
            </pnyc-avatar>
            <div class="customer-dropdown-text"
                [title]="activeCustomer()!.firstName + ' ' + activeCustomer()!.lastName">
                {{ activeCustomer()!.firstName }} {{ activeCustomer()!.lastName }}
            </div>
        } @else {
            <div class="customer-dropdown-text">{{'CUSTOMER_TOOLBAR.TITLES.CUSTOMERS' | translate}}
            </div>
        }
        <pnyc-icon class="customer-dropdown-trigger" [iconName]="'chevron-down'">
        </pnyc-icon>
    </div>

    <ng-template #customerMenu>

        <div class="customer-dropdown-menu">

            @if (!searchPattern() && customersQuery.isLoaded() && !customersQuery.value()?.length) {
                <div class="customer-dropdown-empty pnyc-empty-mask">

                    <div class="pnyc-empty-mask-content">

                        <div class="pnyc-empty-mask-icon-wrap">
                            <pnyc-icon class="pnyc-empty-mask-icon" [iconName]="'user'">
                            </pnyc-icon>
                        </div>

                        <div class="pnyc-empty-mask-title">
                            {{'CUSTOMER_TOOLBAR.TITLES.NO_CUSTOMERS' | translate}}
                        </div>

                        <div class="pnyc-empty-mask-subtitle">
                            {{'CUSTOMER_TOOLBAR.TITLES.ADD_YOUR_FIRST_CUSTOMER' | translate}}
                        </div>

                        <div class="pnyc-empty-mask-footer">
                            <pnyc-button class="pnyc-empty-mask-btn" [appearanceType]="'flat'"
                                [text]="'CUSTOMER_TOOLBAR.TITLES.ADD_CUSTOMER_TITLE'" [iconName]="'plus'"
                                (clicked)="addCustomerClicked()">
                            </pnyc-button>
                        </div>

                    </div>

                </div>
            } @else {

                <div class="customer-dropdown-menu-header">
                    <pnyc-input class="customer-dropdown-search" [value]="searchValue()" [appearance]="'outline'"
                        [placeholder]="'CUSTOMER_TOOLBAR.TITLES.SEARCH_CUSTOMERS'" [prefixIcon]="'search'"
                        (changed)="onSearchChanged($event)">
                    </pnyc-input>
                </div>

                <div class="customer-dropdown-menu-content">
                    @if (customersQuery.value()?.length) {

                        @if (activeCustomer()) {
                            <pnyc-list-item [text]="'CUSTOMER_TOOLBAR.TITLES.CLEAR_SELECTION'" [iconName]="'close'"
                                (clicked)="clearCustomer()">
                            </pnyc-list-item>
                        }

                        @if (searchPattern()) {
                            @for (customer of customersQuery.value(); track customer.id) {
                                <ng-container *ngTemplateOutlet="customerItem; context: { $implicit: customer }">
                                </ng-container>
                            }
                        } @else {
                            @if (hotProspectsList().length) {
                                <pnyc-list-item class="customer-dropdown-divider-title customer-dropdown-item"
                                    [type]="'header'" [text]="'CUSTOMER_TOOLBAR.TITLES.HOT_PROSPECTS'">
                                </pnyc-list-item>

                                @for (customer of hotProspectsList(); track customer.id) {
                                    <ng-container *ngTemplateOutlet="customerItem; context: { $implicit: customer }">
                                    </ng-container>
                                }
                            }

                            @if (customersList().length) {
                                <pnyc-list-item class="customer-dropdown-divider-title customer-dropdown-item"
                                    [type]="'header'" [text]="'CUSTOMER_TOOLBAR.TITLES.ALL_CUSTOMERS'">
                                </pnyc-list-item>

                                @for (customer of customersList(); track customer.id) {
                                    <ng-container *ngTemplateOutlet="customerItem; context: { $implicit: customer }">
                                    </ng-container>
                                }
                            }
                        }

                    } @else if (customersQuery.isLoaded()) {
                        <div class="customer-dropdown-empty pnyc-empty-mask">

                            <div class="pnyc-empty-mask-content">

                                <div class="pnyc-empty-mask-icon-wrap">
                                    <pnyc-icon class="pnyc-empty-mask-icon" [iconName]="'search'">
                                    </pnyc-icon>
                                </div>

                                <div class="pnyc-empty-mask-title">
                                    {{ 'CUSTOMER_TOOLBAR.TITLES.NO_CUSTOMERS_FOUND' | translate }}
                                </div>

                                <div class="pnyc-empty-mask-subtitle">
                                    <div>
                                        {{ 'CUSTOMER_TOOLBAR.TITLES.NO_CUSTOMER_SEARCH_RESULT' | translate: { text: searchPattern() } }}
                                    </div>
                                    <div>
                                        {{ 'CUSTOMER_TOOLBAR.TITLES.PLEASE_TRY_AGAIN_OR' | translate }}
                                        <u
                                            class="customer-dropdown-empty-link">{{ 'CUSTOMER_TOOLBAR.TITLES.ADD_CUSTOMER' | translate }}</u>
                                    </div>
                                </div>

                                <div class="pnyc-empty-mask-footer">
                                    <pnyc-button class="pnyc-empty-mask-btn pnyc-empty-mask-btn--stroke"
                                        [text]="'CUSTOMER_TOOLBAR.TITLES.CLEAR_SEARCH'" (clicked)="onSearchChanged()">
                                    </pnyc-button>
                                    <pnyc-button class="pnyc-empty-mask-btn"
                                        [text]="'CUSTOMER_TOOLBAR.TITLES.ADD_CUSTOMER_TITLE'" [iconName]="'plus'"
                                        (clicked)="addCustomerClicked()">
                                    </pnyc-button>
                                </div>

                            </div>

                        </div>
                    }

                </div>

                <div class="customer-dropdown-menu-footer">
                    <pnyc-button class="customer-dropdown-menu-footer-btn"
                        [text]="'CUSTOMER_TOOLBAR.TITLES.VIEW_ALL_CUSTOMERS'"
                        (clicked)="onViewCustomersClicked(); customerMenuDropdown.close()">
                    </pnyc-button>
                </div>

            }

        </div>

    </ng-template>

    <ng-template #customerItem let-customer>
        <user-short-card class="customer-dropdown-item" [user]="customer" [crmSynced]="customer.isCrmSynced ?? false"
            [isActive]="customer.id === activeCustomerId()" [actionIconName]="'folders'"
            [actionTitle]="'CUSTOMER_TOOLBAR.TITLES.PORTFOLIO'"
            (selected)="setCustomer(customer.id); customerMenuDropdown.close()"
            [secondaryActionIconName]="'user-circle'" [secondaryActionTitle]="'CUSTOMER_TOOLBAR.TITLES.OPEN_PROFILE'"
            (secondaryActionClicked)="openCustomerProfile(customer.id); customerMenuDropdown.close()">

            <customer-avatar-status pnycAvatarStatus [customer]="customer">
            </customer-avatar-status>

            @if (customer.liked || customer.newMatches || customer.appointments || customer.messages) {
                <customer-short-info-card additional-info [customer]="customer">
                </customer-short-info-card>
            }

        </user-short-card>
    </ng-template>

</div>